import { PATHS } from './paths';
import { OfferType } from '@/types';

export type MenuItem = { label: string; link: string; hiddenInProd?: boolean };

export const MENU_ITEMS: MenuItem[] = [
  { label: 'navigation.sell', link: `/${PATHS.HOUSING}?offerType=${OfferType.SELL}` },
  { label: 'navigation.rent', link: `/${PATHS.HOUSING}?offerType=${OfferType.RENT}` },
  { label: 'navigation.projects', link: `/${PATHS.PROJECTS}` },
  { label: 'navigation.brokers', link: `/${PATHS.BROKERS}` },
  { label: 'navigation.blog', link: `/${PATHS.BLOG}`, hiddenInProd: true },
];
